import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';

// In-session cache so the same path isn't resolved twice per page load
const cache = new Map();

/**
 * Accepts either:
 *   - A full URL (CloudFront, https://...) → returned as-is
 *   - A Firebase Storage path (audio/bitcoin.mp3) → resolved via getDownloadURL
 */
const resolveAudioUrl = async (pathOrUrl) => {
  if (!pathOrUrl) return null;
  if (pathOrUrl.startsWith('http')) return pathOrUrl;

  if (cache.has(pathOrUrl)) return cache.get(pathOrUrl);

  const url = await getDownloadURL(ref(storage, pathOrUrl));
  cache.set(pathOrUrl, url);
  return url;
};

export default resolveAudioUrl;
